
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/causes",
      function () {
        return require("private-next-pages/causes/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/causes"])
      });
    }
  